import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Blocked extends QuestionPassState {
    id = QuestionPassStateId.Blocked;
    name = 'Blockierte Fragen';
    color = '';
    orderInProgressbar = 11;
    isDefaultFiltered = true;
}
